

const requests ={
  base: 'https://api.openweathermap.org/data/2.5/',
  key : '54cdd1797dd5846a4c064d87f4887cd7'
}


export default requests;
